import React from 'react';
import EditJobForm from '../../components/EditJobForm/EditJobForm';

const EditJob = () => {

    // rendering the edit job page here
    return (
        <>
            <EditJobForm />
        </>
    );
};

export default EditJob;